import React from "react";
import { FieldRenderProps } from "react-final-form";

import { FormLabel } from "@material-ui/core";

import Editor from "components/Editor";

import FormControlError from "../FormControlError";
import withFieldControl from "../FieldControl";

import {
  Container,
  ControlWrapper,
  EditorFieldContainer,
  Wrapper,
} from "./styles";

type Props = {
  config?: string;
  title?: string;
  required?: boolean;
  action?: React.ReactNode;
} & FieldRenderProps<any>;

class EditorFieldControl extends React.Component<Props> {
  onChange = (value: string) => {
    const { input } = this.props;

    const event: any = {
      target: { value },
    };
    input.onChange(event);
  };

  render() {
    const {
      config,
      title,
      required,
      action,
      input,
      meta,
      ...props
    } = this.props;

    const error = meta.touched && meta.error;

    return (
      <ControlWrapper>
        <Container>
          <FormLabel required={required} error={error}>
            {title}
          </FormLabel>
          <EditorFieldContainer hasError={error}>
            <Wrapper>
              <Editor
                config={config}
                content={input.value}
                onChange={this.onChange}
                {...props}
              />
            </Wrapper>
          </EditorFieldContainer>
          {error && <FormControlError error={error} />}
        </Container>
      </ControlWrapper>
    );
  }
}

export default withFieldControl(EditorFieldControl);
